<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width="24"
    height="24"
  ><path
    fill="#FFF"
    d="M342 0H0v341.3h512V0z"
  /><path
    fill="#6DA544"
    d="M0 0h171v342H0z"
  /><path
    fill="#D80027"
    d="M342 0h171v342H342z"
  /></svg>
</template>
